import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { pick, prop } from 'ramda';

import { Button } from '@core/js/components/common/Button';
import { Logo } from '@core/js/components/main/DefaultHeader/components/Logo/Logo';

import { SvgIcon } from '@interlayer/js/custom/components/common/SvgIcon';

import { MyBalance } from '@theme/js/components/main/DefaultHeader/components/MyBalance/MyBalance';

import * as hooks from '@core/js/components/main/DefaultHeader/hooks';
import { openSidebar } from '@core/js/components/main/MyAccountSidebar/store/actions';
import { useComponentTranslations } from '@core/js/hooks/component';
import { useNavigate } from '@core/js/hooks/navigate';
import { useAppSelector, useMyAccountSidebarSelector, useUserSelector } from '@core/js/store/hooks';

import { triggerCloseLeftMenu, useHandleToggleLeftMenu } from '@interlayer/js/components/main/DefaultHeader/sun/helper';
import { AUTOMATED_TEST_IDS } from '@interlayer/js/custom/constants';
import { clsx } from '@interlayer/js/utils/classNames.util';

import style from './MobileHeader.scss';

export const MobileHeader: React.FC = () => {
    const translate = useComponentTranslations();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const { registrationURL } = useAppSelector(pick(['registrationURL']));
    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const { handleToggleLeftMenu } = useHandleToggleLeftMenu();
    const isSidebarOpened = useMyAccountSidebarSelector(prop('isOpened'));
    const showSidebar = useCallback(() => dispatch(openSidebar()), [dispatch]);

    const handleJoinNow = () => {
        navigate(registrationURL);
    };

    return (
        <div onClick={triggerCloseLeftMenu} className={style.header}>
            <div className={style.info}>
                <SvgIcon
                    type="hamburger-menu"
                    onClick={handleToggleLeftMenu}
                    className={clsx(style.btnMenu, 'cms-icon-side-menu')}
                    color="#646464"
                />

                <Logo />
            </div>

            <div className={style.controls}>
                {isLoggedIn
                    ? (
                        <>
                            <MyBalance/>

                            <SvgIcon
                                className={clsx(style.accountIcon, { [style.isPointerEventsNone]: isSidebarOpened })}
                                onClick={showSidebar}
                                type="my-account"
                                color="#ed1c24"
                            />
                        </>
                    )
                    : (
                        <>
                            {registrationURL && (
                                <Button
                                    color="success"
                                    size="medium"
                                    variant="rounded"
                                    className={clsx(style.register, style.control)}
                                    onClick={handleJoinNow}
                                >
                                    {translate('login.button.join_now')}
                                </Button>
                            )}

                            <Button
                                color="generic"
                                size="medium"
                                variant="rounded"
                                view="secondary"
                                className={clsx(style.login, style.control, AUTOMATED_TEST_IDS.login)}
                                onClick={onLoginButtonClick}
                            >
                                {translate('login.button.loginHeader')}
                            </Button>
                        </>
                    )
                }
            </div>
        </div>
    );
};
